import Vue from "vue";
import Vuex from "vuex";
import crud from "./store/crud";
import search from "./store/search";
import auth from "./store/auth";

Vue.use(Vuex);

const dress = crud("dress");
const event = crud("event");
const eventtype = crud("eventtype");
const color = crud("color");
const brand = crud("brand");
const size = crud("size");
const client = crud("client");

export default new Vuex.Store({
  modules: {
    dress,
    event,
    eventtype,
    color,
    brand,
    size,
    search,
    client,
    auth
  }
});
